/* CUBE STORE - prenotazione con acconto, carrello

   1) sotto ogni riga in preordine mette il riquadro con i tre importi
      (totale / acconto / saldo) e la scelta di come verra' pagato il saldo;
   2) blocca il pagamento finche' la scelta non e' stata fatta.

   La scelta si salva come proprieta' della riga d'ordine, cosi' compare
   sotto l'articolo nell'ordine, nella mail di notifica e nel documento di
   trasporto. Nota: cambiare le proprieta' cambia la chiave della riga,
   quindi dopo il salvataggio la chiave va riletta dal carrello aggiornato.

   Le proprieta' esistenti vanno conservate: l'app PreOrder Globo ne scrive
   una sua (_is_preorder) e sovrascriverla la romperebbe.

   Il blocco copre il tasto Check-out e i pulsanti rapidi (Shop Pay, PayPal,
   Apple Pay, Google Pay): quelli saltano il checkout normale, quindi
   lasciarli attivi renderebbe il vincolo aggirabile con un clic. */
(function () {
  var PROP = 'Saldo 90%';

  var OPTIONS = [
    { value: 'Bonifico bancario', note: 'Buono omaggio dedicato' },
    { value: 'Carta o PayPal', note: 'Link di pagamento via email' },
    { value: 'HeyLight 20 rate', note: 'TAN 0 · TAEG 0' },
    { value: 'HeyLight fino a 36 rate', note: 'Finanziamento' },
    { value: 'SeQura 3 / 6 / 12 rate', note: 'Pagamento rateale' },
    { value: 'Deciderò quando arriva', note: '' }
  ];

  /* scelte conosciute, per chiave di riga: sopravvivono ai ridisegni del
     carrello, che ricreano gli elementi ma non ricaricano la pagina */
  var choices = {};
  var boxes = [];

  function data() {
    var node = document.getElementById('cube-preorder-data');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function rowFor(key) {
    return document.querySelector('tr[data-key="' + key + '"]');
  }

  function missing() {
    var payload = data();
    if (!payload || !payload.active) return 0;
    var count = 0;
    payload.lines.forEach(function (line) {
      if (!line.preorder) return;
      var chosen = Object.prototype.hasOwnProperty.call(choices, line.key)
        ? choices[line.key]
        : line.choice;
      if (!chosen) count++;
    });
    return count;
  }

  /* ---------- blocco del pagamento ---------- */

  function gateMessage(container) {
    var msg = container.querySelector('.cube-po-gate');
    if (msg) return msg;
    msg = document.createElement('p');
    msg.className = 'cube-po-gate';
    msg.textContent = 'Scegli come vuoi saldare per procedere al pagamento.';
    container.insertBefore(msg, container.firstChild);
    return msg;
  }

  function updateGate() {
    var blocked = missing() > 0;

    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var button = ctas.querySelector('.cart__checkout-button');
      var extra = ctas.querySelector('.additional-checkout-buttons');

      if (button) {
        button.disabled = blocked;
        button.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      }
      if (extra) extra.classList.toggle('cube-po-blocked', blocked);

      if (blocked) {
        gateMessage(ctas).hidden = false;
      } else {
        var msg = ctas.querySelector('.cube-po-gate');
        if (msg) msg.remove();
      }
    });

    boxes.forEach(function (entry) {
      var required = entry.box.querySelector('.cube-po__required');
      if (required) required.hidden = !!entry.state.choice;
    });
  }

  function focusMissing() {
    for (var i = 0; i < boxes.length; i++) {
      if (!boxes[i].state.choice) {
        boxes[i].box.scrollIntoView({ block: 'center', behavior: 'smooth' });
        var required = boxes[i].box.querySelector('.cube-po__required');
        if (required) {
          required.hidden = false;
          required.classList.remove('is-flash');
          void required.offsetWidth;
          required.classList.add('is-flash');
        }
        return;
      }
    }
  }

  function guard(event) {
    if (missing() === 0) return;
    var ctas = event.target.closest ? event.target.closest('.cart__ctas') : null;
    if (!ctas) return;
    if (event.target.closest('.cube-cart-full')) return;

    event.preventDefault();
    event.stopPropagation();
    focusMissing();
  }

  /* ---------- riquadro ---------- */

  function buildBox(line, index, percent) {
    var box = document.createElement('div');
    box.className = 'cube-po';

    var current = Object.prototype.hasOwnProperty.call(choices, line.key)
      ? choices[line.key]
      : line.choice;

    var options = OPTIONS.map(function (opt) {
      var checked = current === opt.value ? ' checked' : '';
      var selected = current === opt.value ? ' is-selected' : '';
      var note = opt.note ? '<small>' + opt.note + '</small>' : '';
      return (
        '<label class="cube-po__option' + selected + '">' +
        '<input type="radio" name="cube-po-' + index + '" value="' + opt.value + '"' + checked + '>' +
        '<span><b>' + opt.value + '</b>' + note + '</span>' +
        '</label>'
      );
    }).join('');

    /* la data di arrivo vive nella frase di apertura: se manca, si dice
       comunque che serve l'acconto */
    var intro = line.arrival
      ? 'La bici è prevista in arrivo il <b>' + line.arrival + '</b> (data indicativa), per riservarla richiediamo acconto del <b>' + percent + ' %</b>'
      : 'Per riservarla richiediamo acconto del <b>' + percent + ' %</b>';

    box.innerHTML =
      '<div class="cube-po__head">' +
        '<p class="cube-po__intro">' + intro + '</p>' +
        '<div class="cube-po__figures">' +
          '<div class="cube-po__figure"><span>Prezzo totale</span><strong>' + line.total + '</strong></div>' +
          '<div class="cube-po__figure cube-po__figure--now"><span>Paghi ora (' + percent + '%)</span><strong>' + line.deposit + '</strong></div>' +
          '<div class="cube-po__figure"><span>Saldo</span><strong>' + line.balance + '</strong></div>' +
        '</div>' +
      '</div>' +
      '<div class="cube-po__choice">' +
        '<p class="cube-po__title">Quando arriva la bici con quale modalità di pagamento vuoi procedere al saldo?</p>' +
        '<div class="cube-po__options">' + options + '</div>' +
        '<p class="cube-po__required"' + (current ? ' hidden' : '') + '>Scelta obbligatoria per procedere al pagamento.</p>' +
        '<p class="cube-po__saved" hidden>Scelta salvata.</p>' +
      '</div>';

    return box;
  }

  function save(state, value, box) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === state.key) item = cart.items[i];
        }
        if (!item) return null;

        var props = {};
        for (var name in item.properties || {}) {
          if (Object.prototype.hasOwnProperty.call(item.properties, name)) {
            props[name] = item.properties[name];
          }
        }
        props[PROP] = value;

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: state.key, quantity: item.quantity, properties: props })
        }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (it.variant_id === state.variantId && it.properties && it.properties[PROP] === value) {
            choices[state.key] = value;
            state.key = it.key;
            choices[state.key] = value;
          }
        }
        var saved = box.querySelector('.cube-po__saved');
        if (saved) {
          saved.hidden = false;
          setTimeout(function () { saved.hidden = true; }, 2500);
        }
        updateGate();
      });
  }

  function mount() {
    var payload = data();
    if (!payload || !payload.active) return;

    var percent = payload.percent || 10;
    boxes = [];

    payload.lines.forEach(function (line, index) {
      if (!line.preorder) return;

      var current = Object.prototype.hasOwnProperty.call(choices, line.key)
        ? choices[line.key]
        : line.choice;

      var row = rowFor(line.key);
      if (!row) return;

      if (row.dataset.cubePreorder !== '1') {
        row.dataset.cubePreorder = '1';

        var details = row.querySelector('.cart-items__details');
        if (details && !details.querySelector('.cube-po-tag')) {
          var tag = document.createElement('span');
          tag.className = 'cube-po-tag';
          tag.textContent = 'Prenotazione';
          details.insertBefore(tag, details.firstChild);
        }

        var state = { key: line.key, variantId: line.variantId, choice: current };
        var box = buildBox(line, index, percent);

        var holder = document.createElement('tr');
        holder.className = 'cube-po-row';
        var cell = document.createElement('td');
        cell.colSpan = row.children.length;
        cell.appendChild(box);
        holder.appendChild(cell);
        row.parentNode.insertBefore(holder, row.nextSibling);

        box.addEventListener('change', function (event) {
          var input = event.target;
          if (!input || input.type !== 'radio') return;

          box.querySelectorAll('.cube-po__option').forEach(function (opt) {
            opt.classList.toggle('is-selected', opt.contains(input));
          });

          state.choice = input.value;
          updateGate();
          save(state, input.value, box);
        });

        row.cubePoEntry = { box: box, state: state };
      }

      if (row.cubePoEntry) boxes.push(row.cubePoEntry);
    });

    updateGate();
  }

  function init() {
    mount();

    document.addEventListener('click', guard, true);
    document.addEventListener('submit', function (event) {
      if (missing() === 0) return;
      var form = event.target;
      if (!form || !form.classList || !form.classList.contains('cart-form')) return;
      event.preventDefault();
      focusMissing();
    }, true);

    var root = document.querySelector('cart-items-component') || document.body;
    new MutationObserver(function () {
      requestAnimationFrame(mount);
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
